<div class="section-account bg-white p-t-0">
  <div class=" d-flex p-4">
    <div class="p-2 bg-white">
      <div class="navbar-header mb-3">
        <div *ngIf="profileDetails" class="row">
          <div class="col-auto pr-0">
            <div class="profile-userpic">
              <img src="{{profileDetails.profilepic}}" class="image-cover" alt="">
            </div>
          </div>
          <div class="col text-left">
            <h5 class="mt-4 mb-0  pl-2 user-name-title">{{profileDetails.fullName}}</h5>
            <!-- <button (click)="editProfile()" class="btn btn-sm btn-white pl-2 editbutton"><i
                class="pi pi-fw pi-pencil"></i> Edit
              Profile</button> -->
          </div>
        </div>
      </div>
      <nav class="navbar navbar-vertical navbar-expand-lg">
        <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical"
          [style]="{'width':'300px'}">
          <a class="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab"
            aria-controls="v-pills-home" aria-selected="true"> <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="25.259" height="25.593" viewBox="0 0 25.259 25.593">
                <path id="Icon_material-dashboard" data-name="Icon material-dashboard"
                  d="M4.5,18.718H15.726V4.5H4.5Zm0,11.375H15.726V21.562H4.5Zm14.033,0H29.759V15.875H18.533Zm0-25.593v8.531H29.759V4.5Z"
                  transform="translate(-4.5 -4.5)" fill="#000000" />
              </svg>
            </span>Dashboard</a>
          <a class="nav-link" id="v-pills-orders-tab" data-toggle="pill" href="#v-pills-orders" role="tab"
            aria-controls="v-pills-orders" aria-selected="false"> <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="23.268" height="26.592" viewBox="0 0 23.268 26.592">
                <path id="Icon_open-document" data-name="Icon open-document"
                  d="M0,0V26.592H23.268V13.3H9.972V0ZM13.3,0V9.972h9.972ZM3.324,6.648H6.648V9.972H3.324Zm0,6.648H6.648V16.62H3.324Zm0,6.648h13.3v3.324H3.324Z"
                  fill="#000000" />
              </svg>
            </span>Orders / Wish List</a>
          <a class="nav-link" id="v-pills-payment-tab" data-toggle="pill" href="#v-pills-payment" role="tab"
            aria-controls="v-pills-payment" aria-selected="false"> <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="29.609" height="24" viewBox="0 0 29.609 24">
                <path id="Icon_material-payment" data-name="Icon material-payment"
                  d="M29.648,6H5.961A2.958,2.958,0,0,0,3.015,9L3,27a2.97,2.97,0,0,0,2.961,3H29.648a2.97,2.97,0,0,0,2.961-3V9A2.97,2.97,0,0,0,29.648,6Zm0,21H5.961V18H29.648Zm0-15H5.961V9H29.648Z"
                  transform="translate(-3 -6)" />
              </svg>
            </span>Payment Status</a>
          <a class="nav-link" id="v-pills-todoList-tab" data-toggle="pill" href="#v-pills-todoList" role="tab"
            aria-controls="v-pills-todoList" aria-selected="false"> <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="29.609" height="24" viewBox="0 0 29.609 24">
                <path id="Icon_material-payment" data-name="Icon material-payment"
                  d="M29.648,6H5.961A2.958,2.958,0,0,0,3.015,9L3,27a2.97,2.97,0,0,0,2.961,3H29.648a2.97,2.97,0,0,0,2.961-3V9A2.97,2.97,0,0,0,29.648,6Zm0,21H5.961V18H29.648Zm0-15H5.961V9H29.648Z"
                  transform="translate(-3 -6)" />
              </svg>

            </span>To Do List</a>
          <a class="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile"
            (click)="onTabClick('profile_information')" role="tab" aria-controls="v-pills-profile"
            aria-selected="false"> <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="26.64" height="20.244" viewBox="0 0 26.64 20.244">
                <path id="Icon_metro-profile" data-name="Icon metro-profile"
                  d="M29.236,10.6H27.373V7.772l-3.846-.06.02,2.892H11.991l.079-2.892L8.3,7.772v2.892L6.4,10.6a1.916,1.916,0,0,0-1.9,1.928v13.5a1.916,1.916,0,0,0,1.9,1.928H29.236a1.916,1.916,0,0,0,1.9-1.928v-13.5A1.916,1.916,0,0,0,29.236,10.6ZM24.479,8.676h1.9v3.856h-1.9ZM12.11,15.243c1.149,0,2.082,1.241,2.082,2.772s-.932,2.772-2.082,2.772-2.082-1.241-2.082-2.772.932-2.772,2.082-2.772ZM9.256,8.676h1.9v3.856h-1.9ZM7.988,24.05s.225-1.834.738-2.18a7.223,7.223,0,0,1,1.989-.576s.957,1.036,1.364,1.036,1.363-1.036,1.363-1.036a7.2,7.2,0,0,1,1.989.576c.6.407.753,2.18.753,2.18h-8.2Zm19.346-.914H18.77v-.964h8.563Zm0-1.928H18.77v-.964h8.563Zm0-1.928H18.77v-.964h8.563Zm0-1.928H18.77v-.964h8.563Z"
                  transform="translate(-4.499 -7.712)" />
              </svg>
            </span>Profile Information</a>
          <!-- <a class="nav-link" id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab"
            aria-controls="v-pills-settings" aria-selected="false"><span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="26.64" height="20.244" viewBox="0 0 26.64 20.244">
                <path id="Icon_metro-profile" data-name="Icon metro-profile"
                  d="M29.236,10.6H27.373V7.772l-3.846-.06.02,2.892H11.991l.079-2.892L8.3,7.772v2.892L6.4,10.6a1.916,1.916,0,0,0-1.9,1.928v13.5a1.916,1.916,0,0,0,1.9,1.928H29.236a1.916,1.916,0,0,0,1.9-1.928v-13.5A1.916,1.916,0,0,0,29.236,10.6ZM24.479,8.676h1.9v3.856h-1.9ZM12.11,15.243c1.149,0,2.082,1.241,2.082,2.772s-.932,2.772-2.082,2.772-2.082-1.241-2.082-2.772.932-2.772,2.082-2.772ZM9.256,8.676h1.9v3.856h-1.9ZM7.988,24.05s.225-1.834.738-2.18a7.223,7.223,0,0,1,1.989-.576s.957,1.036,1.364,1.036,1.363-1.036,1.363-1.036a7.2,7.2,0,0,1,1.989.576c.6.407.753,2.18.753,2.18h-8.2Zm19.346-.914H18.77v-.964h8.563Zm0-1.928H18.77v-.964h8.563Zm0-1.928H18.77v-.964h8.563Zm0-1.928H18.77v-.964h8.563Z"
                  transform="translate(-4.499 -7.712)" />
              </svg>
            </span>Account Settings</a> -->
          <a class="nav-link" id="v-pills-logout-tab" data-toggle="pill" href="#v-pills-logout" role="tab"
            aria-controls="v-pills-logout" (click)="onTabClick('logout')" aria-selected="false"> <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="25.259" height="25.593" viewBox="0 0 25.259 25.593">
                <path id="Icon_material-dashboard" data-name="Icon material-dashboard"
                  d="M4.5,18.718H15.726V4.5H4.5Zm0,11.375H15.726V21.562H4.5Zm14.033,0H29.759V15.875H18.533Zm0-25.593v8.531H29.759V4.5Z"
                  transform="translate(-4.5 -4.5)" fill="#000000" />
              </svg>
            </span>Logout</a>

        </div>
      </nav>
    </div>
    <div class="pl-3 pt-0 flex-grow-1">
      <div class="tab-content col mt-0" id="v-pills-tabContent">
        <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
          <h1 class="mt-0 mb-0 page-title">Welcome to Eazy Venue</h1>
          <p>You can check and manage your Orders, Wishlist , Account Manage, Meeting Schedule .</p>
          <!-- TAB 1 content wrapper-->
          <div class="row">
            <div class="col-sm-4">
              <div class="card p-0 mb-4">
                <div class="card-header bg-white">
                  <h5 class="card-title mb-0"><i class="pi pi-briefcase text-danger"></i> Orders / Wish List</h5>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-auto pr-1">
                      <h3 class="mb-0 text-danger">6</h3>
                    </div>
                    <div class="col pl-1">
                      <div class="pt-2">Orders Completed</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-auto pr-1">
                      <h5 class="mb-0 text-success">10</h5>
                    </div>
                    <div class="col pl-1">Venues in a Wish List</div>
                  </div>

                </div>
                <div class="card-footer text-center bg-white"><a href="#" class="btn btn-sm btn-danger">View More</a>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="card p-0 mb-4">
                <div class="card-header bg-white">
                  <h5 class="card-title mb-0"><i class="pi pi-money-bill text-danger"></i> Payment Status</h5>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-auto pr-1">
                      <h3 class="mb-0 text-danger">₹70,000</h3>
                    </div>
                    <div class="col pl-1">
                      <div class="pt-2">Pending</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-auto pr-1">
                      <h5 class="mb-0 text-success">₹30,000</h5>
                    </div>
                    <div class="col pl-1">Paid till date</div>
                  </div>
                </div>
                <div class="card-footer text-center bg-white"><a href="#" class="btn btn-sm btn-danger">View More</a>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="card p-0 mb-4">
                <div class="card-header bg-white">
                  <h5 class="card-title mb-0"><i class="pi pi-check-square text-danger"></i> To Do List</h5>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-auto pr-1">
                      <h3 class="mb-0 text-danger">10</h3>
                    </div>
                    <div class="col pl-1">
                      <div class="pt-2">Tasks Completed</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-auto pr-1">
                      <h5 class="mb-0 text-success">20</h5>
                    </div>
                    <div class="col pl-1">Tasks Listed</div>
                  </div>

                </div>
                <div class="card-footer text-center bg-white"><a href="#" class="btn btn-sm btn-danger">View More</a>
                </div>
              </div>
            </div>
          </div>
          <!--End TAB 1 content wrapper-->
        </div>
        <div class="tab-pane fade" id="v-pills-orders" role="tabpanel" aria-labelledby="v-pills-orders-tab">
          <h1 class="mt-0 mb-0 page-title">Orders / Wish List</h1>
          <!-- <p>The starting state of the menu will appear collapsed on smaller screens, and will appear non-collapsed on
            larger screens.</p> -->
          <!-- TAB 2 content wrapper-->
          <app-orders></app-orders>
          <!-- END TAB 2 content wrapper-->
        </div>
        <div class="tab-pane fade" id="v-pills-payment" role="tabpanel" aria-labelledby="v-pills-payment-tab">
          <h1 class="mt-0 mb-0 page-title">Payment Status</h1>
          <p>The starting state of the menu will appear collapsed on smaller screens, and will appear non-collapsed on
            larger screens.</p>

          <!-- TAB 3 content wrapper-->

          <!-- END TAB 3 content wrapper-->
        </div>
        <div class="tab-pane fade" id="v-pills-todoList" role="tabpanel" aria-labelledby="v-pills-todoList-tab">
          <h1 class="mt-0 mb-0 page-title">To Do List</h1>
          <p>The starting state of the menu will appear collapsed on smaller screens, and will appear non-collapsed on
            larger screens.</p>
          <!-- TAB 4 content wrapper-->
          <ol class="list-group list-group-numbered">
            <li class="list-group-item d-flex justify-content-between align-items-start">
              <div class="ms-2 me-auto">
                <h6 class="mb-0"><input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"> Subheading</h6>
                Cras justo odio
              </div>
              <span class="badge bg-success rounded-pill text-light">Completed</span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-start">
              <div class="ms-2 me-auto">
                <h6 class="mb-0">Subheading</h6>
                Cras justo odio
              </div>
              <span class="badge bg-primary rounded-pill text-light">Pending</span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-start">
              <div class="ms-2 me-auto">
                <h6 class="mb-0">Subheading</h6>
                Cras justo odio
              </div>
              <span class="badge bg-primary rounded-pill">14</span>
            </li>
          </ol>
          <!-- END TAB 4 content wrapper-->
        </div>
        <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">

          <h1 class="mt-0 mb-0 page-title">Profile Information</h1>
          <!-- TAB 5 content wrapper-->
          <div *ngIf="profileDetails" class="col-md-12  tab-div-section">
            <app-user-profile-edit></app-user-profile-edit>
            <!-- <div class="row">
              <label>First Name</label>
              <span>{{profileDetails.firstName}}</span>
            </div>
            <div class="row">
              <label>Last Name</label>
              <span>{{profileDetails.lastName}}</span>
            </div>
            <div class="row">
              <label>Mobile Number</label>
              <span>{{profileDetails.mobileNumber}}</span>
            </div>
            <div class="row">
              <label>Profile Picture</label>
              <img src="{{profileDetails.profilepic}}">
            </div>
            <div class=" row">
              <label>Birth Date</label>
              <span>{{profileDetails.dob|date:"dd/MM/YYY"}}</span>
            </div>
            <div class="row">
              <label>Gender</label>
              <span>{{profileDetails.gender}}</span>
            </div> -->
          </div>
          <!-- END TAB 5 content wrapper-->
        </div>
        <div class="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab">
          <h1 class="mt-0 mb-0 page-title">Account Settings</h1>
          <p>The starting state of the menu will appear collapsed on smaller screens, and will appear non-collapsed on
            larger screens.</p>
          <!-- TAB 6 content wrapper-->
          <div class="card">
            <div class="card-body">
              <form>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="first">First Name</label>
                      <input type="text" class="form-control" placeholder="" id="first">
                    </div>
                  </div>
                  <!--  col-md-6   -->

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="last">Last Name</label>
                      <input type="text" class="form-control" placeholder="" id="last">
                    </div>
                  </div>
                  <!--  col-md-6   -->
                </div>


                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="company">Company</label>
                      <input type="text" class="form-control" placeholder="" id="company">
                    </div>


                  </div>
                  <!--  col-md-6   -->

                  <div class="col-md-6">

                    <div class="form-group">
                      <label for="phone">Phone Number</label>
                      <input type="tel" class="form-control" id="phone" placeholder="phone">
                    </div>
                  </div>
                  <!--  col-md-6   -->
                </div>
                <!--  row   -->


                <div class="row">
                  <div class="col-md-6">

                    <div class="form-group">
                      <label for="email">Email address</label>
                      <input type="email" class="form-control" id="email" placeholder="email">
                    </div>
                  </div>
                  <!--  col-md-6   -->

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="url">Your Website <small>Please include http://</small></label>
                      <input type="url" class="form-control" id="url" placeholder="url">
                    </div>

                  </div>
                  <!--  col-md-6   -->
                </div>
                <!--  row   -->


                <label for="contact-preference">When is the best time of day to reach you?</label>
                <div class="radio">
                  <label>
                    <input type="radio" name="contact-preference" id="contact-preference" value="am" checked>Morning
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input type="radio" name="contact-preference" id="contact-preference" value="pm" checked>Evening
                  </label>
                </div>

                <label for="newsletter">Would you like to recieve our email newsletter?</label>
                <div class="checkbox">

                  <label>
                    <input type="checkbox" value="Sure!" id="newsletter"> Sure!
                  </label>
                </div>


                <button type="submit" class="btn btn-primary">Submit</button>
              </form>
            </div>
          </div>

          <!-- END TAB 6 content wrapper-->
        </div>
        <div class="tab-pane fade" id="v-pills-logout" role="tabpanel" aria-labelledby="v-pills-logout-tab">
          <h1 class="mt-0 mb-0 page-title">Logout!</h1>
          <p>The starting state of the menu will appear collapsed on smaller screens, and will appear non-collapsed on
            larger screens.</p>
          <!-- TAB 7 content wrapper-->

          <!-- END TAB 7 content wrapper-->
        </div>
      </div>
    </div>
  </div>
</div>


<section class="profile main-content ">
  <div class="header">
    <!-- <div class="container">
          <div class="top-container">
              <div class="left-header d-flex">
                  <div class="user-image-div mr-3">
                      <img src="assets/img/players/Ankita Raina.jpg" alt="">
                  </div>
                  <div action="#" class="search">
                      <svg class="search__icon" width="22" height="22" viewBox="0 0 22 22" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M10.5418 19.25C15.3513 19.25 19.2502 15.3512 19.2502 10.5417C19.2502 5.73223 15.3513 1.83337 10.5418 1.83337C5.73235 1.83337 1.8335 5.73223 1.8335 10.5417C1.8335 15.3512 5.73235 19.25 10.5418 19.25Z"
                              stroke="#596780" stroke-width="1.5" stroke-linecap="round"
                              stroke-linejoin="round" />
                          <path d="M20.1668 20.1667L18.3335 18.3334" stroke="#596780" stroke-width="1.5"
                              stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <input type="text" class="search__input" placeholder="Search something here">
                  </div>
              </div>
              <div class="user-nav">
                  <button class="calender notification">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-calendar-date-fill" viewBox="0 0 16 16">
                          <path
                              d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zm5.402 9.746c.625 0 1.184-.484 1.184-1.18 0-.832-.527-1.23-1.16-1.23-.586 0-1.168.387-1.168 1.21 0 .817.543 1.2 1.144 1.2z" />
                          <path
                              d="M16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-6.664-1.21c-1.11 0-1.656-.767-1.703-1.407h.683c.043.37.387.82 1.051.82.844 0 1.301-.848 1.305-2.164h-.027c-.153.414-.637.79-1.383.79-.852 0-1.676-.61-1.676-1.77 0-1.137.871-1.809 1.797-1.809 1.172 0 1.953.734 1.953 2.668 0 1.805-.742 2.871-2 2.871zm-2.89-5.435v5.332H5.77V8.079h-.012c-.29.156-.883.52-1.258.777V8.16a12.6 12.6 0 0 1 1.313-.805h.632z" />
                      </svg>
                  </button>
                  <button class="notification">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-chat-left-dots" viewBox="0 0 16 16">
                          <path
                              d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                          <path
                              d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                      </svg>
                  </button>
                  <button class="notification">
                      <svg class="notification__icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M12.0201 2.91003C8.71009 2.91003 6.02009 5.60003 6.02009 8.91003V11.8C6.02009 12.41 5.76009 13.34 5.45009 13.86L4.30009 15.77C3.59009 16.95 4.08009 18.26 5.38009 18.7C9.69009 20.14 14.3401 20.14 18.6501 18.7C19.8601 18.3 20.3901 16.87 19.7301 15.77L18.5801 13.86C18.2801 13.34 18.0201 12.41 18.0201 11.8V8.91003C18.0201 5.61003 15.3201 2.91003 12.0201 2.91003Z"
                              stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" />
                          <path
                              d="M13.8699 3.19994C13.5599 3.10994 13.2399 3.03994 12.9099 2.99994C11.9499 2.87994 11.0299 2.94994 10.1699 3.19994C10.4599 2.45994 11.1799 1.93994 12.0199 1.93994C12.8599 1.93994 13.5799 2.45994 13.8699 3.19994Z"
                              stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                              stroke-linejoin="round" />
                          <path
                              d="M15.02 19.0601C15.02 20.7101 13.67 22.0601 12.02 22.0601C11.2 22.0601 10.44 21.7201 9.90002 21.1801C9.36002 20.6401 9.02002 19.8801 9.02002 19.0601"
                              stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" />
                      </svg>
                  </button>

                  <button class="Burgur-menue">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-list" viewBox="0 0 16 16">
                          <path fill-rule="evenodd"
                              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
                      </svg>
                  </button>


              </div>
          </div>

      </div> -->

    <div class="bg-white newheader">
      <div class="container d-flex align-items-center justify-content-end">


        <!-- Uncomment below if you prefer to use an image logo -->
        <!-- <a href="index.html" class="logo me-auto me-lg-0"><img src="assets/img/logo.png" alt="" class="img-fluid"></a>-->

        <nav id="navbar" class="navbar order-last order-lg-0">
          <ul>
            <li class="active"><a href="profile.html" class="nav-link scrollto">INFO</a></li>
            <li><a href="profileskill.html" class="nav-link scrollto active">Skill </a></li>

            <li><a href="profilerank.html" class="nav-link scrollto">Ranking </a></li>
            <li><a href="matches.html" class="nav-link scrollto">Matches </a></li>
            <li><a href="profileopponents.html" class="nav-link scrollto">Opponents </a></li>
            <li><a href="profileevent.html" class="nav-link scrollto">My Tournaments </a></li>
            <li class=""><a href="profilrequest-history.html" class="nav-link scrollto">Partner
                Request
              </a>
            </li>
            <li class=""><a href="profilcontest-history.html" class="nav-link scrollto">Contest
                History
              </a>
            </li>

            <!-- <li><a href="membership.html" class="nav-link scrollto">Memberships </a></li> -->


          </ul>
          <i class="bi bi-list mobile-nav-toggle"></i>
          <div class="mobile-version-top-bar">
            <nav class="top-bar bg-dark">
              <div class="container">
                <div class="row">
                  <div class="info col-md-6">
                    <div class="media">
                      <div class="media-left">
                        <i class="bi bi-envelope"></i>
                      </div>
                      <div class="media-body">
                        info@tplsport.in
                      </div>
                    </div>
                  </div>
                  <div class="float-right col-md-6">
                    <div class="right-bar-list">
                      <ul>
                        <li class="mobile-d-none"><a href="find-a-partner.html" class="nav-link scrollto"> <button
                              class="btn find-patner-btn"> <span class="mr-3"><i
                                  class="bi bi-binoculars-fill"></i></span>
                              Find A Partner</button> </a>
                        </li>
                        <li class="mobile-d-none"><a class="nav-link scrollto "> <button class="btn Proplayer-btn">
                              <span class="mr-3"><i class="bi bi-people-fill"></i></span>
                              Pro-Player</button> </a></li>
                        <li>
                          <a href=""><i class="bx bx-bell"></i></a>

                        </li>
                        <li>
                          <a href="login.html"><i class="bx bx-user-circle"></i></a>
                        </li>

                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </nav><!-- .navbar -->

        <!-- <a href="#about" class="get-started-btn scrollto">Get Started</a> -->

      </div>



    </div>
  </div>

</section>

<section class="body-section">
  <div class="container">


    <main>
      <div class="col-md-12 user-top-body-header d-flex justify-content-between">

        <div class="left-section">
          <div class="media">
            <div class="media-left">
              <div class="user-image">
                <img src="assets/img/players/1646919224786.jpg" alt="">
              </div>
              <div class="media-body">
                <div class="tag">
                  PRO
                </div>
                <div class="name ">
                  <h4>Amit
                    Shinde</h4>
                </div>
                <div class="col-md-12">
                  <p class="id d-flex">
                    <span> <a href="#" class="flag">
                        <img src="assets/img/players/flag2.png" alt="">
                      </a> ID: R000110896</span><span class="line-separator">|</span><span>Age:
                      -</span> <span class="line-separator">|</span> <span>
                      Form:

                      L

                      W

                      W

                      W

                      W
                    </span>
                    &nbsp;&nbsp;<span class="icon-rin-sports-tennis"></span>
                  </p>

                  <div class="mt-1"><span class="club">Academy:</span> <a href="#" class="club-name">Ultim8 Tennis
                      League (U8L)</a> <a href="javascript:void(0);" class="x-remove-club"
                      style="text-decoration: none;">X</a>
                  </div>
                </div>
                <div class="profiles-buttons">
                  <div class="edite-profile-section">
                    <a href="edit-profile.html" class="btn">
                      <i class='bx bx-pencil'></i> Edit Profile
                    </a>
                  </div>
                  <div class="ref_container">
                    <div class="cool_btn edite-profile-section">

                      <a  target="_blank"><button class="ref_share btn">
                          Referral Code <span class="ref_url"> <i class='bx bx-share-alt'></i>
                          </span></button></a>
                    </div>

                  </div>
                </div>

              </div>

            </div>
          </div>


        </div>


        <div class="right-side-section">
          <div class="box spending-box">

            <div class="pie-chart">
              <canvas id="myChart2" height="180px" width="180px"></canvas>
              <div class="overall-spending">
                <h4>skill
                </h4>
                <span>20.4</span>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div class=" col-md-12 bottom-container tablesections">
        <div class="header-container box w-100">
          <div class=" col-md-12 bottom-container tablesections">
            <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">

              <symbol id="exclamation-triangle-fill" viewBox="0 0 16 16">
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
              </symbol>
            </svg>
          </div>
        </div>
        <div class="media">
          <div class="media-left">

          </div>
        </div>
      </div>



      <div class=" col-md-12 bottom-container tablesections">
        <div class="header-container box w-100">
          <div class="col-md-12 d-flex justify-content-between mb-3">
            <h3 class="section-header">Overview</h3>
            <div class="year-selector">
              <select class="form-select" aria-label="Default select example">
                <option selected>

                  Single</option>
                <option value="1">Double</option>

              </select>
            </div>
          </div>
          <div class="col-md-12 ">
            <table class="fullWidth w-100 text-center">
              <thead>
                <tr>
                  <th>2023</th>
                  <th>Career</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><span class="big"><strong id="win-loss-curr-year">27-8</strong></span>
                    <br><span>W-L</span>
                  </td>
                  <td><span class="big"><strong id="car-win-los">112-20</strong></span>
                    <br><span>W-L</span>
                  </td>
                </tr>
                <tr>
                  <td><span class="big"><strong id="events-partic-curr-year">11</strong></span>
                    <br><span>Tournament Participation</span>
                  </td>
                  <td><span class="big"><strong id="car-events-partic">32</strong></span>
                    <br><span>Tournament Participation</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
      <div class=" col-md-12 bottom-container tablesections">
        <div class="header-container box w-100">
          <div class="col-md-12 d-flex justify-content-between mb-3">
            <h3 class="section-header">Opponents
            </h3>
            <div class="year-selector">

            </div>
          </div>
          <div class="col-md-12 ">
            <div class="opponents-info-body">
              <div class="opponents-info-cards-wrapper">
                <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                  <!---->
                  <div class="rin-card-header"><img src="https://cdn.rankedin.com/images/rin_logo_sm.png"></div>
                  <div class="rin-card-body">
                    <div class="first-name">Vyal</div>
                    <div class="last-name">Adhye</div>
                  </div>
                  <div class="rin-card-footer">
                    <div class="opponents-info-card-footer">
                      <hr>
                      <div class="matches-counter">8</div> <span class="matches-text">Matches</span>
                    </div>
                  </div>
                </div>
                <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                  <!---->
                  <div class="rin-card-header"><img
                      src="https://rankedin-cdn.azureedge.net/images/upload/player/31954thumb.png">
                  </div>
                  <div class="rin-card-body">
                    <div class="first-name">Sanket</div>
                    <div class="last-name">Naik</div>
                  </div>
                  <div class="rin-card-footer">
                    <div class="opponents-info-card-footer">
                      <hr>
                      <div class="matches-counter">7</div> <span class="matches-text">Matches</span>
                    </div>
                  </div>
                </div>
                <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                  <!---->
                  <div class="rin-card-header"><img src="https://cdn.rankedin.com/images/rin_logo_sm.png"></div>
                  <div class="rin-card-body">
                    <div class="first-name">Haresh</div>
                    <div class="last-name">Ramchandani</div>
                  </div>
                  <div class="rin-card-footer">
                    <div class="opponents-info-card-footer">
                      <hr>
                      <div class="matches-counter">6</div> <span class="matches-text">Matches</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="highest-jump-wrapper">
                <div class="highest-skill-jump-wrapper">
                  <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                    <div class="rin-card-title">
                      <div class="highest-skill-jump-header">
                        <div>
                          Highest Skill Jump
                        </div>
                      </div>
                    </div>
                    <div class="rin-card-header">
                      <div class="highest-skill-jump-date">
                        <div><i class='bx bx-calendar'></i>
                          &nbsp;28/11/2021 10:00
                        </div>
                      </div>
                      <hr>
                    </div>
                    <div class="rin-card-body">
                      <div class="highest-skill-jump-body">
                        <div class="left-box">
                          <div class="player-box">
                            <div class="p-name"><span><span><a href="#" class="flag">
                                    <img src="assets/img/players/flag2.png" alt="">
                                  </a>
                                  &nbsp; A. Shinde
                                </span> <!----> <!----></span></div>
                            <div class="p-name"><span><span><a href="#" class="flag">
                                    <img src="assets/img/players/flag2.png" alt="">
                                  </a>
                                  &nbsp;H. Panchal
                                </span> <!----> <!----></span></div>
                          </div>
                          <div class="rating-box">
                            <div class="p-rating"><span>15.03</span><span class="rating-diff">&nbsp;+1.65</span> <!---->
                              <!---->
                            </div>
                            <div class="p-rating"><span>12.68</span> <!----> <!---->
                            </div>
                          </div>
                        </div>
                        <div class="right-box">
                          <div class="score-box">
                            <div>4</div>
                            <div>0</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rin-card-footer">
                      <hr> <a href="#" class="event-name">
                        U8L Singles Tournament
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="Show-more-btn">
              <a href="profileopponents.html"> <button>Show More</button></a>
            </div>
          </div>
        </div>

      </div>

      <div class=" col-md-12 bottom-container tablesections">
        <div class="header-container box w-100">
          <div class="col-md-12 d-flex justify-content-between mb-3">
            <h3 class="section-header">Last Tournaments Played

            </h3>
            <div class="year-selector">

            </div>
          </div>
          <div class="col-md-12 ">
            <div class="opponents-info-body Last-events-played">

              <!-- Swiper -->
              <div class="swiper mySwiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                      <div class="rin-card-title"><span class="rin-type-label tournament">
                          tournament
                        </span></div> <!---->
                      <div class="rin-card-body">
                        <div class="last-events-played-card-body">
                          <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border loser">
                            <div class="rin-card-title"><img
                                src="https://rankedin-cdn.azureedge.net/images/upload/player/31931thumb.png">
                            </div>
                            <div class="rin-card-header"><span class="flag-icon flag-icon-in"></span> <a href="#"
                                class="">
                                <div class="first-name">Amit</div>
                              </a> <a href="#" class="">
                                <div class="last-name">Shinde</div>
                              </a></div> <!----> <!---->
                          </div>
                          <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                            <div class="rin-card-title"><img
                                src="https://rankedin-cdn.azureedge.net/images/upload/player/34227thumb.png">
                            </div>
                            <div class="rin-card-header"><span class="flag-icon flag-icon-in"></span> <a href="#"
                                class="">
                                <div class="first-name">Amit</div>
                              </a> <a href="#" class="">
                                <div class="last-name">Dixit</div>
                              </a></div> <!----> <!---->
                          </div>
                        </div>
                      </div>
                      <div class="rin-card-footer">
                        <div><span class="result-label">0 - 1</span> <span
                            class="detailed-results"><span>2-5<!----></span> <span>
                              (0m)</span></span> <span class="d-flex"><span
                              class="icon-rin-sports-tennis"></span>&nbsp;<a href="#" class=""><span
                                class="event-link-ellipsis">U8L Open
                                Singles Amateurs Championship</span></a></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                      <div class="rin-card-title"><span class="rin-type-label tournament">
                          tournament
                        </span></div> <!---->
                      <div class="rin-card-body">
                        <div class="last-events-played-card-body">
                          <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border winner">
                            <div class="rin-card-title"><img
                                src="https://rankedin-cdn.azureedge.net/images/upload/player/31931thumb.png">
                            </div>
                            <div class="rin-card-header"><span class="flag-icon flag-icon-in"></span> <a href="#"
                                class="">
                                <div class="first-name">Amit</div>
                              </a> <a href="#" class="">
                                <div class="last-name">Shinde</div>
                              </a></div> <!----> <!---->
                          </div>
                          <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                            <div class="rin-card-title"><img
                                src="https://rankedin-cdn.azureedge.net/images/upload/player/34227thumb.png">
                            </div>
                            <div class="rin-card-header"><span class="flag-icon flag-icon-in"></span> <a href="#"
                                class="">
                                <div class="first-name">Amit</div>
                              </a> <a href="#" class="">
                                <div class="last-name">Dixit</div>
                              </a></div> <!----> <!---->
                          </div>
                        </div>
                      </div>
                      <div class="rin-card-footer">
                        <div><span class="result-label">1 - 0 </span> <span
                            class="detailed-results"><span>2-5<!----></span> <span>
                              (0m)</span></span> <span class="d-flex"><span
                              class="icon-rin-sports-tennis"></span>&nbsp;<a href="#" class=""><span
                                class="event-link-ellipsis">U8L Open
                                Singles Amateurs Championship</span></a></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                      <div class="rin-card-title"><span class="rin-type-label tournament">
                          tournament
                        </span></div> <!---->
                      <div class="rin-card-body">
                        <div class="last-events-played-card-body">
                          <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border loser">
                            <div class="rin-card-title"><img
                                src="https://rankedin-cdn.azureedge.net/images/upload/player/31931thumb.png">
                            </div>
                            <div class="rin-card-header"><span class="flag-icon flag-icon-in"></span> <a href="#"
                                class="">
                                <div class="first-name">Amit</div>
                              </a> <a href="#" class="">
                                <div class="last-name">Shinde</div>
                              </a></div> <!----> <!---->
                          </div>
                          <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                            <div class="rin-card-title"><img
                                src="https://rankedin-cdn.azureedge.net/images/upload/player/34227thumb.png">
                            </div>
                            <div class="rin-card-header"><span class="flag-icon flag-icon-in"></span> <a href="#"
                                class="">
                                <div class="first-name">Amit</div>
                              </a> <a href="#" class="">
                                <div class="last-name">Dixit</div>
                              </a></div> <!----> <!---->
                          </div>
                        </div>
                      </div>
                      <div class="rin-card-footer">
                        <div><span class="result-label">0 - 1</span> <span
                            class="detailed-results"><span>2-5<!----></span> <span>
                              (0m)</span></span> <span class="d-flex"><span
                              class="icon-rin-sports-tennis"></span>&nbsp;<a href="#" class=""><span
                                class="event-link-ellipsis">U8L Open
                                Singles Amateurs Championship</span></a></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                      <div class="rin-card-title"><span class="rin-type-label tournament">
                          tournament
                        </span></div> <!---->
                      <div class="rin-card-body">
                        <div class="last-events-played-card-body">
                          <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border loser">
                            <div class="rin-card-title"><img
                                src="https://rankedin-cdn.azureedge.net/images/upload/player/31931thumb.png">
                            </div>
                            <div class="rin-card-header"><span class="flag-icon flag-icon-in"></span> <a href="#"
                                class="">
                                <div class="first-name">Amit</div>
                              </a> <a href="#" class="">
                                <div class="last-name">Shinde</div>
                              </a></div> <!----> <!---->
                          </div>
                          <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                            <div class="rin-card-title"><img
                                src="https://rankedin-cdn.azureedge.net/images/upload/player/34227thumb.png">
                            </div>
                            <div class="rin-card-header"><span class="flag-icon flag-icon-in"></span> <a href="#"
                                class="">
                                <div class="first-name">Amit</div>
                              </a> <a href="#" class="">
                                <div class="last-name">Dixit</div>
                              </a></div> <!----> <!---->
                          </div>
                        </div>
                      </div>
                      <div class="rin-card-footer">
                        <div><span class="result-label">0 - 1</span> <span
                            class="detailed-results"><span>2-5<!----></span> <span>
                              (0m)</span></span> <span class="d-flex"><span
                              class="icon-rin-sports-tennis"></span>&nbsp;<a href="#" class=""><span
                                class="event-link-ellipsis">U8L Open
                                Singles Amateurs Championship</span></a></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                      <div class="rin-card-title"><span class="rin-type-label tournament">
                          tournament
                        </span></div> <!---->
                      <div class="rin-card-body">
                        <div class="last-events-played-card-body">
                          <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border loser">
                            <div class="rin-card-title"><img
                                src="https://rankedin-cdn.azureedge.net/images/upload/player/31931thumb.png">
                            </div>
                            <div class="rin-card-header"><span class="flag-icon flag-icon-in"></span> <a href="#"
                                class="">
                                <div class="first-name">Amit</div>
                              </a> <a href="#" class="">
                                <div class="last-name">Shinde</div>
                              </a></div> <!----> <!---->
                          </div>
                          <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                            <div class="rin-card-title"><img
                                src="https://rankedin-cdn.azureedge.net/images/upload/player/34227thumb.png">
                            </div>
                            <div class="rin-card-header"><span class="flag-icon flag-icon-in"></span> <a href="#"
                                class="">
                                <div class="first-name">Amit</div>
                              </a> <a href="#" class="">
                                <div class="last-name">Dixit</div>
                              </a></div> <!----> <!---->
                          </div>
                        </div>
                      </div>
                      <div class="rin-card-footer">
                        <div><span class="result-label">0 - 1</span> <span
                            class="detailed-results"><span>2-5<!----></span> <span>
                              (0m)</span></span> <span class="d-flex"><span
                              class="icon-rin-sports-tennis"></span>&nbsp;<a href="#" class=""><span
                                class="event-link-ellipsis">U8L Open
                                Singles Amateurs Championship</span></a></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                      <div class="rin-card-title"><span class="rin-type-label tournament">
                          tournament
                        </span></div> <!---->
                      <div class="rin-card-body">
                        <div class="last-events-played-card-body">
                          <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border loser">
                            <div class="rin-card-title"><img
                                src="https://rankedin-cdn.azureedge.net/images/upload/player/31931thumb.png">
                            </div>
                            <div class="rin-card-header"><span class="flag-icon flag-icon-in"></span> <a href="#"
                                class="">
                                <div class="first-name">Amit</div>
                              </a> <a href="#" class="">
                                <div class="last-name">Shinde</div>
                              </a></div> <!----> <!---->
                          </div>
                          <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                            <div class="rin-card-title"><img
                                src="https://rankedin-cdn.azureedge.net/images/upload/player/34227thumb.png">
                            </div>
                            <div class="rin-card-header"><span class="flag-icon flag-icon-in"></span> <a href="#"
                                class="">
                                <div class="first-name">Amit</div>
                              </a> <a href="#" class="">
                                <div class="last-name">Dixit</div>
                              </a></div> <!----> <!---->
                          </div>
                        </div>
                      </div>
                      <div class="rin-card-footer">
                        <div><span class="result-label">0 - 1</span> <span
                            class="detailed-results"><span>2-5<!----></span> <span>
                              (0m)</span></span> <span class="d-flex"><span
                              class="icon-rin-sports-tennis"></span>&nbsp;<a href="#" class=""><span
                                class="event-link-ellipsis">U8L Open
                                Singles Amateurs Championship</span></a></span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div class="Show-more-btn">
              <a href="profileevent.html"> <button>Show More</button></a>
            </div>
          </div>
        </div>

      </div>


      <div class="bottom-container  chart-div">


        <div class="bottom-container__left">
          <div class="box spending-box">
            <div class="header-container justify-content-start chart-heading">
              <h3 class="section-header">Ranking Movement</h3>
              <p class="text-left mb-0">
                Historic data for player
              </p>

            </div>
            <div class="bar-chart">
              <canvas id="myChart4" height="400px" width="660px"></canvas>
            </div>
          </div>


        </div>
        <div class="bottom-container__left">
          <div class="box spending-box">
            <div class="header-container justify-content-start chart-heading">
              <h3 class="section-header">Skill History</h3>
              <p class="text-left mb-0 hidden">
                Historic data for player
              </p>


            </div>
            <div class="bar-chart">
              <canvas id="myChart3" height="400px" width="660px"></canvas>
            </div>
          </div>


        </div>

      </div>

    </main>
  </div>
</section>